var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentFormShow
    ? _c(
        "div",
        {
          staticClass: "render-item_text render-item",
          class: [
            ((_obj = {}), (_obj["full-line"] = _vm.fullLine), _obj),
            _vm.customClass
          ],
          style: {
            fontSize: _vm.fontSize,
            lineHeight: _vm.lineHeight,
            width: _vm.align !== "none" ? "100%" : undefined,
            textAlign: _vm.align !== "none" ? _vm.align : undefined
          }
        },
        [
          _vm.wrap ? _c("br") : _vm._e(),
          _vm._l(_vm.indent, function(i) {
            return [_vm._v("  ")]
          }),
          _c(
            "span",
            {
              class: {
                italic: _vm.italic == "all",
                strong: _vm.strong == "all"
              },
              style: {
                borderBottom:
                  _vm.showTextUnderline === "underline"
                    ? "1px solid #5c5c5c"
                    : "none",
                paddingBottom: "2px",
                color: _vm.renderColor
              }
            },
            [
              _vm.underline == "underline"
                ? _c("span", [_vm._v(" ")])
                : _vm._e(),
              _vm._v(_vm._s(_vm.labelName)),
              _vm.underline == "underline"
                ? _c("span", [_vm._v(" ")])
                : _vm._e(),
              _c(
                "span",
                {
                  staticStyle: {
                    color: "transparent",
                    display: "contents",
                    "word-break": "break-all"
                  }
                },
                [_vm._v(_vm._s(_vm.seat))]
              )
            ]
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11d582e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11d582e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/render_item/RenderText.vue
// module id = null
// module chunks = 